import { fileIcons } from '../../consts/fileTypes';
import { FileContent, FileIcon, FileWrapper, DeleteButton } from './style';
import TrashIcon from '../../assets/icons/trash.svg?react';
import { useCallback } from 'react';
import React from 'react';

interface FileProps {
  type?: string;
  title?: string;
  size?: any;
  isActive?: boolean;
  onDelete: () => void;
}

const File = ({
  type = 'excel',
  title = 'Example.docx',
  size = '314 kb.',
  isActive = false,
  onDelete
}: FileProps) => {
  const Icon = fileIcons[type];

  const handleDeleteClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onDelete();
    },
    [onDelete]
  );

  return (
    <FileWrapper
      // @ts-ignore
      isActive={isActive}
      data-tooltip-id="file-name"
      data-tooltip-content={title}
      data-tooltip-variant="light"
    >
      <FileIcon>
        <Icon />
      </FileIcon>
      <FileContent>
        <h5>{title}</h5>
        <p>{(size / 1024).toFixed(0)} KB.</p>
      </FileContent>
      {/* @ts-ignore */}
      <DeleteButton isActive={isActive} onClick={handleDeleteClick}>
        <TrashIcon />
      </DeleteButton>
    </FileWrapper>
  );
};

export default File;
